import RefFriendSavedPresenter from "./RefFriendSavedPresenter";

export default class RefFriendSavedPresenterFactory {
    static make(token, fromList) {
        let presenter = new RefFriendSavedPresenter(fromList);
        return presenter;
    }
}